module.exports = __webpack_public_path__ + "img/106.15a0445d.svg";